<template lang="pug">
.video-page

  // 標題 & 時間
  .block-1
    .title 利嘉小水力發電設備
    .date-time
      span {{ dateTimeString }}
      span {{ time }}

  // 即時資料
  .block-2
    .img-zero-emission
      .semicircle-title
        img(:src='imgSrc.semicircle_title')
      .semicircle-pin(:class="{'co2-animate': isShowZeroEmission}")
        img(:src='imgSrc.semicircle_pin')
      .semicircle-bg
        img(:src='imgSrc.semicircle_bg')
      .flower-bloom(:class="{'co2-animate': isShowZeroEmission}")
        img(:src='imgSrc.flower_bloom')
      .flower-bud(:class="{'co2-animate': isShowZeroEmission}")
        img(:src='imgSrc.flower_bud')
      .forest-grey(:class="{'co2-animate': isShowZeroEmission}")
        img(:src='imgSrc.forest_grey')
      .forest-green(:class="{'co2-animate': isShowZeroEmission}")
        img(:src='imgSrc.forest_green')
    .realtime-data
      .data-text(
        v-for="text in realtimeData"
        :class='text.class'
        :style='realtimeDataPosition(text)'
        ) {{ text.data }}
    .power-animation
      video(
        v-if='isShowZeroEmission'
        ref="video"
        src='@/assets/video/block2/at_waterwheel_slower.mp4'
        autoplay
        loop
        width='100%'
        )

      img(
        :src='imgSrc.animationDefault'
        width='160px'
        )

    .img-wrapper
      img(:src='imgSrc.block2_bg')

  // SCADA
  .block-4
    realtime-scada(
      ref='block4'
      :gcpToggleAutomaticStatus='gcpToggleAutomaticStatus'
      )
</template>

<script>
import realtimeScada from './realtime-page/scada.vue'
import lottie from '@/components/public/lottie.vue'
import animationData from '../../public/at_waterwheel_slower.json'
export default {
  components: { realtimeScada, lottie },
  data () {
    return {
      isShowZeroEmission: false,
      imgSrc: {
        block2_bg: require('@/assets/video/block2/img_realtime_bg2.svg'),
        animationDefault: require('@/assets/video/block2/icon_animation_waterwheel_default.svg'),

        forest_grey: require('@/assets/video/block2/icon_indi_zeroemission_off0.svg'),
        forest_green: require('@/assets/video/block2/icon_indi_zeroemission_on88888.svg'),
        flower_bud: require('@/assets/video/block2/icon_indi_flower_1.png'),
        flower_bloom: require('@/assets/video/block2/icon_indi_flower_3.png'),
        semicircle_bg: require('@/assets/video/block2/icon_indi_panel.svg'),
        semicircle_title: require('@/assets/video/block2/icon_indi_co2_zh.svg'),
        semicircle_pin: require('@/assets/video/block2/icon_indi_pin.svg'),

        block4: require('@/assets/video/img4.svg'),
        demo_block1: require('@/assets/video/img1.svg'),
        demo_block2: require('@/assets/video/img2.svg'),
        demo_block3: require('@/assets/video/img3.svg')
      },
      time: null,
      interval: null,
      timer: null,
      realtimeData: [
        { top: 298, left: 110 + 10, class: 'spacing-lg', data_key: 'co2', data: '0', label: '減碳' },
        { top: 404, left: 230, class: 'spacing-sm', data_key: 'realtime_flow', data: '0.0', label: '原水流量' },
        { top: 506, left: 230, class: 'spacing-sm', data_key: 'realtime_pressure', data: '0.00', label: '原水高程' },
        { top: 612, left: 230, class: 'spacing-sm', data_key: 'realtime_kw', data: '0.0', label: '發電功率' },
        { top: 714, left: 230, class: 'spacing-sm', data_key: 'pr', data: '0.0', label: '發電稼動' }
      ],
      gcpToggleAutomaticStatus: false,
      lottieOpt: {
        loop: true,
        autoplay: true,
        animationData: animationData
      }
    }
  },
  created () {
    this.initClock()

    window.setTimeout(() => {
      this.isShowZeroEmission = true
      console.log('RealTime Data: 儀表指針轉動, 秒數: 5')

      this.$refs.block4.showWaterFlow()

      this.updateRealtimeData()
      this.timer = window.setInterval(() => {
        this.updateRealtimeData()
      }, 60 * 1000)
    }, 2 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.timer)
  },
  methods: {
    async updateRealtimeData () {
      const resData = await this.getRealtimeData()

      this.gcpToggleAutomaticStatus = resData.gcp_toggle_automatic_status
      this.realtimeData = this.realtimeData.map(d => {
        let data = resData[d.data_key]

        if (data || data === 0) {
          // co2 不加小數點
          // 水位(高程) 到小數點後兩位 (由後端處理)
          if (d.data_key === 'co2' || d.data_key === 'realtime_flow') {
            data = data.toFixed(0)
          } else if (d.data_key === 'realtime_pressure') {
            data = data.toFixed(2)
          } else {
            data = data.toFixed(1)
          }

          d.data = '' + data
          return d
        } else {
          d.data = '--'
          return d
        }
      })
    },
    async getRealtimeData () {
      try {
        const ligaPlantId = 1
        const { data } = await this.axios.get('/api/lcd', {
          params: { plant_id: ligaPlantId }
        })

        return data
      } catch (error) {
        console.error(error)
      }
    },
    realtimeDataPosition (obj) {
      return {
        position: 'absolute',
        top: obj.top + 'px',
        left: obj.left + 'px'
      }
    },
    initClock () {
      this.interval = window.setInterval(() => {
        this.time = Intl.DateTimeFormat(navigator.language, {
          hourCycle: 'h23',
          hour: '2-digit',
          minute: 'numeric',
          second: 'numeric'
        }).format()
      }, 1000)
    }
  },
  computed: {
    dateTimeString () {
      const weekDaysCh = ['日', '一', '二', '三', '四', '五', '六']
      const options = { year: 'numeric', month: '2-digit', day: 'numeric' }
      const date = new Date().toLocaleDateString('zh-Hans-CN', options)
      const weekday = new Date().getDay()
      return date + ` (${weekDaysCh[weekday]}) `
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'E1234';
  src: url('/font/E1234-p7pER.ttf') format('truetype');
}

.video-page {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, #fff, #c8c8c8 24%, #ebebeb 49%, #ebebeb 82%, #f0f0f0);

  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s; // 頁面 fade in
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;

  .img-wrapper {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
    }
  }

  .block-1 {
    width: 100%;
    height: 6.2%;
    overflow: hidden;

    text-align: center;
    padding-top: 15px;
    box-sizing: border-box;

    .title {
      font-family: 'Noto Sans TC';
      font-size: 36px;
      letter-spacing: 10px;
      font-weight: bold;
      margin-bottom: 6px;
      color: #0064a0;
      transform: translateX(5px);
    }

    .date-time {
      margin: 0 auto;
      padding: 0 5px;
      width: 410px;
      display: flex;
      justify-content: space-between;

      font-family: Arial, Helvetica, sans-serif;
      font-size: 23px;
      letter-spacing: 5px;
      color: #646464;

      &>span:first-child {
        font-weight: bold;
      }

      &>span:last-child {
        font-weight: 400;
      }
    }
  }

  .block-2 {
    position: relative;
    height: 41.67%;
    overflow: hidden;
    // border: 1px solid red;

    .realtime-data {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;

      .data-text {
        font-family: 'E1234';
        font-size: 56px;
        color: #282828;
      }

      .spacing-lg {
        width: 330px;
        height: 64px;
        text-align: right;
        letter-spacing: 10px;
      }

      .spacing-sm {
        width: 200px;
        height: 64px;
        text-align: right;
        letter-spacing: -11px;
      }
    }

    .img-zero-emission {
      // background: #E4EFFF;
      position: absolute;
      top: 15px;
      left: 30px;
      width: 420px;
      height: 250px;

      .semicircle-title {
        position: absolute;
        top: 125px;
        left: 120px;
        z-index: 6;
      }

      .semicircle-pin {
        position: absolute;
        top: 70px;
        left: 189px;
        z-index: 5;
        transform-origin: 20px 146px;

        transform: rotate(-90deg);
        &.co2-animate {
          animation-name: co2Rotate;
          animation-duration: 5s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          animation-timing-function: ease-in-out;
        }
      }

      .semicircle-bg {
        position: absolute;
        top: 50px;
        left: 50px;
        z-index: 4;
      }

      .flower-bloom {
        position: absolute;
        top: 42px;
        left: 194px;
        z-index: 3;

        opacity: 0;
        &.co2-animate {
          animation-name: co2FadeIn;
          animation-duration: 5s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          animation-timing-function: ease-in-out;
        }
      }

      .flower-bud {
        position: absolute;
        top: 42px;
        left: 194px;
        z-index: 2;

        opacity: 1;
        &.co2-animate {
          animation-name: co2FadeOut;
          animation-duration: 5s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          animation-timing-function: ease-in-out;
        }
      }

      .forest-grey {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        opacity: 1;
        &.co2-animate {
          animation-name: co2FadeOut;
          animation-duration: 5s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          animation-timing-function: ease-in-out;
        }
      }

      .forest-green {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;

        opacity: 0;
        &.co2-animate {
          animation-name: co2FadeIn;
          animation-duration: 5s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          animation-timing-function: ease-in-out;
        }
      }

      @keyframes co2Rotate {
        from {transform: rotate(-90deg);}
        to {transform: rotate(90deg);}
      }

      @keyframes co2FadeIn {
        from {opacity: 0;}
        to {opacity: 1;}
      }

      @keyframes co2FadeOut {
        from {opacity: 1;}
        to {opacity: 0;}
      }
    }

    .power-animation {
      position: absolute;
      top: 370px;
      left: 10px;

      width: 160px;
      height: 408px;

      &>img {
        z-index: 1;
        position: absolute;
        top: 3px;
        left: 0;
      }

      &>.lottie-div {
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
      }

      &>video {
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

  }

  .block-3 {
    height: 14.1%;
    overflow: hidden;
  }

  .block-4 {
    height: 52.08%;
    padding: 30px 40px auto 40px;
    overflow: hidden;
  }
}

.slide-in-from-right {
  transform: translateX(100%);

  &.slide-in {
    animation: slideIn;
    animation-duration: 3s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }
}

.slide-in-from-left {
  transform: translateX(-100%);

  &.slide-in {
    animation: slideIn;
    animation-duration: 3s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }
}

@keyframes slideIn {
  from {}
  to { transform: translateX(0%); }
}
</style>
